/**
 * Created by jimmy on 2019/9/29.
 */

import React, { useState, useEffect } from 'react';

import './index.less';

import * as Utils from '../../common/utils';

import IMG_FOOTER_HOME from '../../common/images/home.png';
import IMG_FOOTER_HOME_SELECTED from '../../common/images/home-selected.png';
import IMG_FOOTER_STORE from '../../common/images/my.png';
import IMG_FOOTER_STORE_SELECTED from '../../common/images/my-selected.png';
import IMG_FOOTER_MIDDLE from '../../common/images/mid.png';
import IMG_FOOTER_MIDDLE_SELECTED from '../../common/images/mid-select.png';
import * as Request from "../../common/request";

const CompModel = props => {
	const { page, showFooter = false, title = '在线设备监管系统', style = {} } = props;
	console.log('page==',page);
	const [userInfo, setUserInfo] = useState('');
	const getUserInfo = async () => {
		const result = await Request.get({
			url: '/user/get'
		});
		if (!result) return;
		console.log('用户信息:',result);
		setUserInfo(result.data);
	};

	useEffect(() => {
		Utils.setTitle(title);
		getUserInfo();
	}, [123]);

	return (
		<div className="page-container" style={style}>
			{props.children}
			{
				!!showFooter && localStorage.getItem('open') != 5 && userInfo && <div className="page-footer">
					<div className={`pfooter-item${page == 'home' ? ' selected' : ''}`} onClick={() => props.history.push('/')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'home' ? IMG_FOOTER_HOME_SELECTED : IMG_FOOTER_HOME})` }} />
						<span style={{ color: page == 'home' ? '#00B46D' : '#333' }}>首页</span>
					</div>

					<div className={`pfooter-item${page == 'upkeep' ? ' selected' : ''}`} onClick={() => props.history.push('/upkeep')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'upkeep' ? IMG_FOOTER_MIDDLE_SELECTED : IMG_FOOTER_MIDDLE})` }} />
						<span style={{ color: page == 'upkeep' ? '#00B46D' : '#333' }}>设备保养</span>
					</div>

					<div className={`pfooter-item${page == 'user' ? ' selected' : ''}`} onClick={() => props.history.push('/user')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'user' ? IMG_FOOTER_STORE_SELECTED : IMG_FOOTER_STORE})` }} />
						<span style={{ color: page == 'user' ? '#00B46D' : '#333' }}>我的</span>
					</div>
				</div>
			}
			{
				!!showFooter && localStorage.getItem('open') == 5 && userInfo && userInfo.type == 5 && <div className="page-footer">
					<div className={`pfooter-item${page == 'admin' ? ' selected' : ''}`} onClick={() => props.history.push('/admin')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'admin' ? IMG_FOOTER_HOME_SELECTED : IMG_FOOTER_HOME})` }} />
						<span style={{ color: page == 'admin' ? '#00B46D' : '#333' }}>首页</span>
					</div>

					<div className={`pfooter-item${page == 'adminupkeep' ? ' selected' : ''}`} onClick={() => props.history.push('/adminupkeep')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'adminupkeep' ? IMG_FOOTER_MIDDLE_SELECTED : IMG_FOOTER_MIDDLE})` }} />
						<span style={{ color: page == 'adminupkeep' ? '#00B46D' : '#333' }}>设备保养</span>
					</div>

					<div className={`pfooter-item${page == 'adminuser' ? ' selected' : ''}`} onClick={() => props.history.push('/adminuser')}>
						<div className="cover" style={{ backgroundImage: `url(${page == 'adminuser' ? IMG_FOOTER_STORE_SELECTED : IMG_FOOTER_STORE})` }} />
						<span style={{ color: page == 'adminuser' ? '#00B46D' : '#333' }}>我的</span>
					</div>
				</div>
			}
		</div>
	);
};

export default CompModel;
